import { clone, setWith } from "lodash";
import { FeedbackData } from "../fields/fields.types";
// import type { ConditionContext } from "@appcraft/common-utils";
// import { evalCondition } from "@appcraft/common-utils/lib/condition";

const { evalCondition } = require("@appcraft/common-utils");

export function setIn<T extends Record<string, any>>(object: T, path: string | string[], value: any): T {
  return setWith(clone(object), path, value, clone);
}

export function applyPatch<T extends Record<string, any>>(data: T, patch: Record<string, any>): T {
  if (typeof patch === "function") {
    return patch(data);
  }
  if (typeof patch === "object") {
    let obj = data;
    // Handle patches like {"foo.bar": "baz"}
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const key in patch) {
      obj = setIn(obj, key, patch[key]);
    }
    return obj;
  }
  // eslint-disable-next-line no-console
  console.error("Unknown patch type", patch);
  return data;
}

type FeedbackCondition = (Record<string, any> & { version?: string }) | undefined | null;

export function isValidCondition(condition: FeedbackCondition, user: any, data: FeedbackData): boolean {
  if (!condition) return true; // Always visible
  if (condition.version === "2") return evalCondition(condition, { user, feedback: data });
  for (const key in condition) {
    // @ts-ignore
    // eslint-disable-next-line eqeqeq
    if (condition[key] == data[key]) return true;
  }

  return false;
}
